import useFlag from './useFlag';

const FLAG = 'flex.content.user-notes';

export function useUserNotesEnabled() {
  const isEnabled = useFlag<boolean>(FLAG, false);

  return Boolean(isEnabled);
}
